<template>
  <el-dialog
    append-to-body
    width="550px"
    title=""
    destroy-on-close
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-loading="loading"
    element-loading-text="图片上传中…"
  >
    <template #title>
      <div class="el-dialog-title">退回</div>
    </template>
    <el-form
      class="staff-from"
      ref="elFormDom"
      label-width="80px"
      label-position="top"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      hide-required-asterisk
    >
      <aiTe ref="aiTeRef" v-model="aiteIdList" @change="aiTeChange"></aiTe>
      <div :class="{'padding-b10':aiteObjList.length}">
        <el-tag size="small" v-for="tag in aiteObjList" @close="tagClose(tag.id)" :key="tag.name" closable>
          {{ tag.name }}
        </el-tag>
      </div>
      <el-form-item label="退回至" prop="optionId">
        <el-select v-model="form.data.optionId" placeholder="请选择">
          <el-option
            v-for="item in flow_list"
            :key="item.optionId"
            :label="item.name"
            :value="item.optionId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="comment">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model.trim="form.data.comment"
          placeholder="请输入审批意见"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="附件" prop="file">
        <template #label>
          附件 <span style="color: #999"></span>
          <uploadfile
            :loading.sync="form.loading"
            :fileList="fileList"
            @setfileList="(files) => (fileList = files)"
          ></uploadfile>
        </template>
      </el-form-item>
      <el-form-item label="" prop="image" class="imgWrap">
        <template #label>
          图片 <span style="color: #999">(最多选择9张图片)</span
          ><uploadimg
            :loading.sync="form.loading"
            :fileListImg="fileListImg"
            @imgChange="(files) => (fileListImg = files)"
          ></uploadimg>
        </template>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading.sync="form.loading"
          :disabled="form.loading"
          @click="submitForm"
          >完成</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import { getStorage } from "@/storage";
import uploadfile from "@/components/uploadfile.vue";
import uploadimg from "@/components/uploadimg.vue";
import aiTe from "@/components/aiTe.vue";
export default {
  name: "MyComment",
  mixins: [mixinTable],
  components: { uploadfile, uploadimg ,aiTe},
  data() {
    return {
      token: getStorage("token"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          id: "",
          comment: "",
          picture: [],
          files: [],
          level: "",
          optionId:"",
        },
        rules: {},
      },
      fileList: [],
      fileListImg: [],
      flow_list: [],
      aiteIdList:[],
      aiteObjList:[],
    };
  },
  methods: {
    tagClose(id) {
      this.aiteIdList = this.aiteIdList.filter((item) => item !== id);
      this.aiteObjList = this.aiteObjList.filter((item) => item.id !== id);
      this.$refs.aiTeRef.personObjList = this.aiteObjList;
    },
    getDetail(row, id) {
      if (!!row.id) {
        this.isChange = true;
        this.$nextTick(() => {
          this.form.data.id = id;
          console.log(row.flow_list.filter((item) => row.flow_level > item.level),'666666666666666666666')
          this.flow_list = row.flow_list
            .filter((item) => row.flow_level > item.level)
            .map((item) => {
              return {
                level: item.level,
                optionId: item.id,
                name:
                  {
                    0: "发起人",
                    1: "主管",
                    2: "上级直属主管",
                    3: (item.type == 4 ? "转交" : "") + "审批人",
                    4: "多人或签",
                    5: "多人会签",
                    6: "办理人",
                    7: "抄送",
                    9: "部门负责人",
                  }[item.person_type] +
                  "-" +
                  item.employees
                    .reduce((a, b) => a + "," + b.name, "")
                    .substring(1),
              };
            });
            console.log(this.flow_list,'eeeeeeeeeeeeeeeeeeeeeeee')
          
          // this.form.data.level =
          //   this.flow_list.length > 0
          //     ? this.flow_list[this.flow_list.length - 1].level
          //     : "";
          let level = this.flow_list.length > 0? this.flow_list[this.flow_list.length - 1].level: "";
          if(level) {
            let  index = this.flow_list.findIndex(item => item.level == level)
            if(index != -1) {
              this.form.data.optionId = this.flow_list[index].optionId
            }
          }
        });
      }
    },
    reset(done) {
      this.isChange = false;
      this.fileList = [];
      this.fileListImg = [];
      this.aiteIdList = [];
      this.aiteObjList = [];
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    aiTeChange(val) {
      this.aiteObjList = val;
      console.log('收到','aiteObjList',this.aiteObjList)
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    submitForm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let _fileList = this.fileList.map((v) => {
            return {
              name: v.name,
              file: v.url,
            };
          });
          let _fileListImg = this.fileListImg.map((v) => v.url);
          if (!this.form.data.optionId) {
            return this.$message.warning("请选择退回人员");
          }
          if (
            _fileList.length == 0 &&
            _fileListImg.length == 0 &&
            this.form.data.comment == ""
          ) {
            return this.$message.warning("请输入审批意见");
          }
          let at_employees = this.aiteObjList.length>0?this.aiteObjList.map(item => {
              return {
                employee_id:item.id,
                name:item.name
              }
            }):[];
          let _params = {
            id: this.form.data.id,
            comment: this.form.data.comment,
            // level: this.form.data.level,
            level:'',
            picture: JSON.stringify(_fileListImg),
            files: JSON.stringify(_fileList),
            at_employees:JSON.stringify(at_employees)
          };
          if(at_employees.length) {
            let str = '';
            at_employees.forEach(e => {
              str += `@${e.name} `
            });
            _params.comment = str +' ' +this.form.data.comment;
          }
          let levelObj = this.flow_list.find(item => item.optionId == this.form.data.optionId);
          if(levelObj) {
            _params.level = levelObj.level;
          }
          this.form.loading = true;
          this.$http
            .post("/admin/employeeApproval/sendBack", _params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.imgWrap ::v-deep .avatar-uploader-icon {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.padding-b10{
  padding-bottom: 10px;
}
</style>